<script setup lang="ts">
// Vue & Plugins

// Components
import ShiftArea from './content/ShiftArea.vue'
import SkillPreviewPopover from '../../skills/components/popovers/SkillPreviewPopover.vue'

// Composables
import { useEmployeeShiftOfferUpdateMutation } from '../../employee_shift/composables/useEmployeeShiftOffer'

// Models
import { SiteID } from '../../sites/models/site'
import { Shift } from '../models/shift'
import { EmployeeID } from '../../employees/models/employee'

// Other
import { DateTime } from 'luxon'

const { siteId, employeeId, shift } = defineProps<{
  siteId: SiteID
  employeeId: EmployeeID
  shift: Shift
}>()

const emit = defineEmits<{
  updated: [shift: Shift]
}>()

const { mutate: updateEmployee, isPending: isUpdateEmployeePending } =
  useEmployeeShiftOfferUpdateMutation()

const rejectPressed = () => {
  updateEmployee(
    {
      siteId,
      shiftId: shift.id,
      employeeId,
      status: 'rejected',
    },
    {
      onSuccess: () => {
        emit('updated', shift)
      },
    },
  )
}
</script>

<template>
  <Card>
    <template #content>
      <div class="grid grid-cols-12 items-center gap-x-4">
        <div class="col-span-2">
          {{ shift.startDate.toLocaleString(DateTime.DATE_MED) }}
        </div>

        <div class="col-span-3">
          <Tag
            :severity="'info'"
            :value="`${shift.startDate.toLocaleString(DateTime.TIME_SIMPLE)} - ${shift.endDate.toLocaleString(DateTime.TIME_SIMPLE)}`"
          />
        </div>

        <ShiftArea v-if="shift.area" :area="shift.area" class="col-span-3" />

        <SkillPreviewPopover
          v-if="shift.skills !== undefined"
          :skills="shift.skills"
          class="col-span-3"
        />

        <div class="flex gap-x-2 place-self-end">
          <Button
            icon="pi pi-times"
            severity="danger"
            :loading="isUpdateEmployeePending"
            @click="rejectPressed"
          />
        </div>
      </div>
    </template>
  </Card>
</template>
